(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('diamanti-media-slider')){
 class DiamantiMediaSlider extends HTMLElement{
  connectedCallback(){
   if(this.connected)return;this.connected=true;
   this.row=this.querySelector('.diamanti-media-row');this.buttons=this.querySelectorAll('[data-direction]');if(!this.row)return;
   this.update=()=>{const max=this.row.scrollWidth-this.row.clientWidth;this.buttons.forEach(b=>{b.disabled=Number(b.dataset.direction)<0?this.row.scrollLeft<=2:this.row.scrollLeft>=max-2;});};
   this.click=e=>{const b=e.target.closest('[data-direction]');if(!b||!this.contains(b))return;const card=this.row.querySelector('.diamanti-media-card');const gap=parseFloat(getComputedStyle(this.row).gap)||0;this.row.scrollBy({left:Number(b.dataset.direction)*((card?card.getBoundingClientRect().width:340)+gap)});};
   this.addEventListener('click',this.click);this.row.addEventListener('scroll',this.update,{passive:true});this.observer=new ResizeObserver(this.update);this.observer.observe(this.row);this.update();
  }
  disconnectedCallback(){this.removeEventListener('click',this.click);this.row?.removeEventListener('scroll',this.update);this.observer?.disconnect();this.connected=false;}
 }
 customElements.define('diamanti-media-slider',DiamantiMediaSlider);
}

  } catch(e) { console.error(e); }
})();
})();
